import React, { FC } from 'react';
import CustomExternalAnchor from '../../customExternalAnchor';
import RoutableSitecoreLink from '../../routableSitecoreLink';
import { TLinkChildrenAndIcon } from '../types/cta.types';
import CTARightIcon from './rightIcon';

const HasChildrenOrIcon: FC<TLinkChildrenAndIcon> = (props) => {
  const { isEditing, ctaClassName, field, isSecondaryCTA, iconField, iconName, hasCTAIcon, children, target } = props;
  // if it has children or the arrow, the sitecore link component gets duplicated on EE
  const ctaRightIcon = hasCTAIcon && <CTARightIcon isSecondaryCTA={isSecondaryCTA} iconField={iconField} iconName={iconName} />;

  if (isEditing) {
    return (
      <span className={ctaClassName}>
        <CustomExternalAnchor field={field} />
        {children}
        {ctaRightIcon}
      </span>
    );
  } else if (children) {
    return (
      <RoutableSitecoreLink field={field} className={ctaClassName}>
        {children}
        {ctaRightIcon}
      </RoutableSitecoreLink>
    );
  } else if (hasCTAIcon) {
    return (
      <RoutableSitecoreLink field={field} target={target} className={ctaClassName}>
        {field.value.text || field.value.href}
        {ctaRightIcon}
      </RoutableSitecoreLink>
    );
  }
  return null;
};

export default HasChildrenOrIcon;
